// ─────────────────────────────────────────────────────────────────────────────
// INDIA DATA — States → Districts → Colleges + Metro Proximity
// workProximityScore: 0-100 based on metro access + job market density
// ─────────────────────────────────────────────────────────────────────────────

export const METRO_CITIES = [
  "Bangalore", "Mumbai", "Delhi", "Chennai", "Hyderabad",
  "Kolkata", "Pune", "Ahmedabad", "Surat", "Jaipur",
  "Lucknow", "Chandigarh", "Kochi", "Indore", "Nagpur"
];

// placement: % of students placed | avgPackage: LPA | metroDistance: km to nearest metro
export const INDIA_DATA = {

  // ── KARNATAKA ─────────────────────────────────────────────────────────────
  Karnataka: {
    districts: {
      "Bangalore Urban": {
        nearestMetro: "Bangalore",
        metroDistance: 0,
        workProximityScore: 98,
        colleges: [
          { name: "Indian Institute of Science (IISc)", placement: 99, avgPackage: 28, type: "Central University" },
          { name: "RV College of Engineering", placement: 95, avgPackage: 12, type: "Private Engineering" },
          { name: "BMS College of Engineering", placement: 91, avgPackage: 10, type: "Private Engineering" },
          { name: "PES University", placement: 93, avgPackage: 11, type: "Deemed University" },
          { name: "MS Ramaiah Institute of Technology", placement: 90, avgPackage: 9.5, type: "Private Engineering" },
          { name: "Christ University", placement: 85, avgPackage: 7, type: "Deemed University" },
          { name: "Jain University", placement: 80, avgPackage: 6, type: "Deemed University" },
          { name: "Dayananda Sagar University", placement: 78, avgPackage: 6.5, type: "Private University" },
          { name: "New Horizon College of Engineering", placement: 75, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Bangalore College", placement: 65, avgPackage: 4.5, type: "Private" },
        ]
      },
      "Bangalore Rural": {
        nearestMetro: "Bangalore",
        metroDistance: 40,
        workProximityScore: 82,
        colleges: [
          { name: "REVA University", placement: 78, avgPackage: 5.5, type: "Private University" },
          { name: "East West Institute of Technology", placement: 70, avgPackage: 4.8, type: "Private Engineering" },
          { name: "Presidency College", placement: 68, avgPackage: 4.5, type: "Private" },
          { name: "Other Rural Bangalore College", placement: 55, avgPackage: 3.5, type: "Private" },
        ]
      },
      "Mysuru": {
        nearestMetro: "Bangalore",
        metroDistance: 148,
        workProximityScore: 70,
        colleges: [
          { name: "University of Mysore", placement: 72, avgPackage: 5, type: "State University" },
          { name: "JSS Science and Technology University", placement: 85, avgPackage: 8, type: "Deemed University" },
          { name: "NIE Mysore", placement: 82, avgPackage: 7, type: "Private Engineering" },
          { name: "Vidyavardhaka College of Engineering", placement: 74, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Mysuru College", placement: 60, avgPackage: 4, type: "Private" },
        ]
      },
      "Dharwad": {
        nearestMetro: "Bangalore",
        metroDistance: 420,
        workProximityScore: 55,
        colleges: [
          { name: "Karnataka University Dharwad", placement: 65, avgPackage: 4.5, type: "State University" },
          { name: "BVB College of Engineering", placement: 80, avgPackage: 7, type: "Private Engineering" },
          { name: "SDM College of Engineering", placement: 75, avgPackage: 6, type: "Private Engineering" },
          { name: "Other Dharwad College", placement: 52, avgPackage: 3.5, type: "Private" },
        ]
      },
      "Belagavi": {
        nearestMetro: "Pune",
        metroDistance: 200,
        workProximityScore: 62,
        colleges: [
          { name: "Visvesvaraya Technological University (HQ)", placement: 70, avgPackage: 5, type: "State University" },
          { name: "KLE Technological University", placement: 84, avgPackage: 7.5, type: "Deemed University" },
          { name: "Angadi Institute of Technology", placement: 72, avgPackage: 5.2, type: "Private Engineering" },
          { name: "Other Belagavi College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Tumakuru": {
        nearestMetro: "Bangalore",
        metroDistance: 70,
        workProximityScore: 76,
        colleges: [
          { name: "Siddaganga Institute of Technology", placement: 88, avgPackage: 8, type: "Private Engineering" },
          { name: "Tumkur University", placement: 65, avgPackage: 4.5, type: "State University" },
          { name: "Other Tumakuru College", placement: 58, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Mangaluru": {
        nearestMetro: "Bangalore",
        metroDistance: 350,
        workProximityScore: 65,
        colleges: [
          { name: "NITK Surathkal", placement: 94, avgPackage: 14, type: "NIT" },
          { name: "Manipal Academy of Higher Education", placement: 88, avgPackage: 9, type: "Deemed University" },
          { name: "Sahyadri College of Engineering", placement: 76, avgPackage: 5.8, type: "Private Engineering" },
          { name: "Canara Engineering College", placement: 69, avgPackage: 4.5, type: "Private Engineering" },
          { name: "Alva's Institute of Enginnering", placement: 63, avgPackage: 3.5, type: "Private Engineering" },
          { name: "Other Mangaluru College", placement: 60, avgPackage: 3, type: "Private" },
        ]
      },
      "Kalaburagi": {
        nearestMetro: "Hyderabad",
        metroDistance: 180,
        workProximityScore: 50,
        colleges: [
          { name: "Gulbarga University", placement: 58, avgPackage: 3.8, type: "State University" },
          { name: "PDA College of Engineering", placement: 68, avgPackage: 4.8, type: "Govt Engineering" },
          { name: "Other Kalaburagi College", placement: 48, avgPackage: 3.2, type: "Private" },
        ]
      },
      "Hassan": {
        nearestMetro: "Bangalore",
        metroDistance: 185,
        workProximityScore: 58,
        colleges: [
          { name: "SJCE Hassan", placement: 70, avgPackage: 5, type: "Govt Engineering" },
          { name: "Other Hassan College", placement: 52, avgPackage: 3.5, type: "Private" },
        ]
      },
      "Shivamogga": {
        nearestMetro: "Bangalore",
        metroDistance: 270,
        workProximityScore: 55,
        colleges: [
          { name: "Kuvempu University", placement: 60, avgPackage: 4, type: "State University" },
          { name: "SSIT Tumkur (near campus)", placement: 72, avgPackage: 5.2, type: "Private Engineering" },
          { name: "Other Shivamogga College", placement: 50, avgPackage: 3.3, type: "Private" },
        ]
      },
    }
  },

  // ── TAMIL NADU ────────────────────────────────────────────────────────────
  "Tamil Nadu": {
    districts: {
      "Chennai": {
        nearestMetro: "Chennai",
        metroDistance: 0,
        workProximityScore: 96,
        colleges: [
          { name: "IIT Madras", placement: 99, avgPackage: 32, type: "IIT" },
          { name: "Anna University (CEG)", placement: 92, avgPackage: 10, type: "State University" },
          { name: "SSN College of Engineering", placement: 91, avgPackage: 9.5, type: "Private Engineering" },
          { name: "Vellore Institute of Technology Chennai", placement: 88, avgPackage: 8, type: "Deemed University" },
          { name: "SRM Institute of Science", placement: 85, avgPackage: 7.5, type: "Deemed University" },
          { name: "Saveetha Engineering College", placement: 78, avgPackage: 6, type: "Private Engineering" },
          { name: "Other Chennai College", placement: 65, avgPackage: 4.8, type: "Private" },
        ]
      },
      "Coimbatore": {
        nearestMetro: "Chennai",
        metroDistance: 494,
        workProximityScore: 72,
        colleges: [
          { name: "PSG College of Technology", placement: 93, avgPackage: 9, type: "Private Engineering" },
          { name: "Coimbatore Institute of Technology", placement: 85, avgPackage: 7.5, type: "Govt Engineering" },
          { name: "Amrita School of Engineering", placement: 87, avgPackage: 8, type: "Deemed University" },
          { name: "KCT Coimbatore", placement: 82, avgPackage: 7, type: "Private Engineering" },
          { name: "Other Coimbatore College", placement: 68, avgPackage: 5, type: "Private" },
        ]
      },
      "Vellore": {
        nearestMetro: "Chennai",
        metroDistance: 213,
        workProximityScore: 80,
        colleges: [
          { name: "VIT University", placement: 94, avgPackage: 12, type: "Deemed University" },
          { name: "IIITDM Kancheepuram", placement: 90, avgPackage: 11, type: "Central University" },
          { name: "Other Vellore College", placement: 65, avgPackage: 4.5, type: "Private" },
        ]
      },
      "Madurai": {
        nearestMetro: "Chennai",
        metroDistance: 462,
        workProximityScore: 60,
        colleges: [
          { name: "NIT Trichy (nearby)", placement: 95, avgPackage: 14, type: "NIT" },
          { name: "Madurai Kamaraj University", placement: 65, avgPackage: 4.5, type: "State University" },
          { name: "Thiagarajar College of Engineering", placement: 80, avgPackage: 7, type: "Private Engineering" },
          { name: "Other Madurai College", placement: 58, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Tiruchirappalli": {
        nearestMetro: "Chennai",
        metroDistance: 335,
        workProximityScore: 68,
        colleges: [
          { name: "NIT Trichy", placement: 95, avgPackage: 14, type: "NIT" },
          { name: "Bharathidasan University", placement: 68, avgPackage: 4.8, type: "State University" },
          { name: "RMK Engineering College", placement: 75, avgPackage: 6, type: "Private Engineering" },
          { name: "Other Trichy College", placement: 60, avgPackage: 4.2, type: "Private" },
        ]
      },
      "Salem": {
        nearestMetro: "Chennai",
        metroDistance: 340,
        workProximityScore: 58,
        colleges: [
          { name: "Periyar University", placement: 62, avgPackage: 4.2, type: "State University" },
          { name: "Sri Venkateswara College of Engg", placement: 74, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Salem College", placement: 53, avgPackage: 3.5, type: "Private" },
        ]
      },
    }
  },

  // ── MAHARASHTRA ───────────────────────────────────────────────────────────
  Maharashtra: {
    districts: {
      "Mumbai": {
        nearestMetro: "Mumbai",
        metroDistance: 0,
        workProximityScore: 97,
        colleges: [
          { name: "IIT Bombay", placement: 99, avgPackage: 35, type: "IIT" },
          { name: "VJTI Mumbai", placement: 92, avgPackage: 11, type: "Govt Engineering" },
          { name: "DJ Sanghvi College", placement: 88, avgPackage: 9, type: "Private Engineering" },
          { name: "KJ Somaiya College", placement: 85, avgPackage: 8, type: "Private Engineering" },
          { name: "NMIMS University", placement: 90, avgPackage: 12, type: "Deemed University" },
          { name: "SP Jain School of Global Management", placement: 95, avgPackage: 18, type: "Business School" },
          { name: "Other Mumbai College", placement: 65, avgPackage: 5, type: "Private" },
        ]
      },
      "Pune": {
        nearestMetro: "Pune",
        metroDistance: 0,
        workProximityScore: 93,
        colleges: [
          { name: "College of Engineering Pune (COEP)", placement: 94, avgPackage: 13, type: "Govt Engineering" },
          { name: "Symbiosis Institute of Technology", placement: 88, avgPackage: 9, type: "Deemed University" },
          { name: "Pune Institute of Computer Technology", placement: 90, avgPackage: 10, type: "Private Engineering" },
          { name: "MIT College of Engineering", placement: 85, avgPackage: 8, type: "Private Engineering" },
          { name: "Vishwakarma Institute of Technology", placement: 82, avgPackage: 7.5, type: "Private Engineering" },
          { name: "Other Pune College", placement: 65, avgPackage: 5, type: "Private" },
        ]
      },
      "Nashik": {
        nearestMetro: "Mumbai",
        metroDistance: 167,
        workProximityScore: 68,
        colleges: [
          { name: "K.K. Wagh College of Engineering", placement: 78, avgPackage: 6, type: "Private Engineering" },
          { name: "SSVPS College of Engineering", placement: 72, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Nashik College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Nagpur": {
        nearestMetro: "Nagpur",
        metroDistance: 0,
        workProximityScore: 75,
        colleges: [
          { name: "VNIT Nagpur", placement: 92, avgPackage: 12, type: "NIT" },
          { name: "Priyadarshini College of Engineering", placement: 78, avgPackage: 6, type: "Private Engineering" },
          { name: "G.H. Raisoni College", placement: 80, avgPackage: 6.5, type: "Private Engineering" },
          { name: "Other Nagpur College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Aurangabad": {
        nearestMetro: "Pune",
        metroDistance: 235,
        workProximityScore: 58,
        colleges: [
          { name: "MGM College of Engineering", placement: 72, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Government College of Engineering Aurangabad", placement: 75, avgPackage: 6, type: "Govt Engineering" },
          { name: "Other Aurangabad College", placement: 52, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Thane": {
        nearestMetro: "Mumbai",
        metroDistance: 35,
        workProximityScore: 88,
        colleges: [
          { name: "SIES College of Engineering", placement: 82, avgPackage: 7.5, type: "Private Engineering" },
          { name: "Xavier Institute of Engineering", placement: 80, avgPackage: 7, type: "Private Engineering" },
          { name: "Other Thane College", placement: 68, avgPackage: 5.2, type: "Private" },
        ]
      },
    }
  },

  // ── DELHI / NCR ───────────────────────────────────────────────────────────
  Delhi: {
    districts: {
      "New Delhi": {
        nearestMetro: "Delhi",
        metroDistance: 0,
        workProximityScore: 98,
        colleges: [
          { name: "IIT Delhi", placement: 99, avgPackage: 38, type: "IIT" },
          { name: "Delhi Technological University", placement: 93, avgPackage: 12, type: "Govt Engineering" },
          { name: "NSIT (Netaji Subhas University)", placement: 90, avgPackage: 11, type: "Govt Engineering" },
          { name: "Jamia Millia Islamia", placement: 78, avgPackage: 7, type: "Central University" },
          { name: "Lady Shri Ram College", placement: 82, avgPackage: 8, type: "Central University" },
          { name: "Delhi University (DU) Colleges", placement: 74, avgPackage: 6, type: "Central University" },
          { name: "GGSIPU Affiliated College", placement: 70, avgPackage: 5.5, type: "State University" },
          { name: "Other Delhi College", placement: 60, avgPackage: 4.5, type: "Private" },
        ]
      },
      "North Delhi": {
        nearestMetro: "Delhi",
        metroDistance: 10,
        workProximityScore: 92,
        colleges: [
          { name: "Delhi University North Campus Colleges", placement: 76, avgPackage: 6.5, type: "Central University" },
          { name: "Maharaja Agrasen Institute of Technology", placement: 80, avgPackage: 7.5, type: "Private Engineering" },
          { name: "Other North Delhi College", placement: 62, avgPackage: 5, type: "Private" },
        ]
      },
      "South Delhi": {
        nearestMetro: "Delhi",
        metroDistance: 10,
        workProximityScore: 92,
        colleges: [
          { name: "IIT Delhi (South Campus)", placement: 99, avgPackage: 38, type: "IIT" },
          { name: "South Delhi DU Colleges", placement: 77, avgPackage: 6.8, type: "Central University" },
          { name: "Other South Delhi College", placement: 63, avgPackage: 5.2, type: "Private" },
        ]
      },
    }
  },

  // ── UTTAR PRADESH ─────────────────────────────────────────────────────────
  "Uttar Pradesh": {
    districts: {
      "Lucknow": {
        nearestMetro: "Lucknow",
        metroDistance: 0,
        workProximityScore: 72,
        colleges: [
          { name: "IIT Kanpur (nearby)", placement: 98, avgPackage: 30, type: "IIT" },
          { name: "Lucknow University", placement: 62, avgPackage: 4.5, type: "State University" },
          { name: "BBDNIIT", placement: 70, avgPackage: 5, type: "Private Engineering" },
          { name: "Integral University", placement: 65, avgPackage: 4.8, type: "Private University" },
          { name: "Other Lucknow College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Kanpur": {
        nearestMetro: "Lucknow",
        metroDistance: 79,
        workProximityScore: 70,
        colleges: [
          { name: "IIT Kanpur", placement: 98, avgPackage: 30, type: "IIT" },
          { name: "HBTU Kanpur", placement: 80, avgPackage: 7, type: "Govt Engineering" },
          { name: "Other Kanpur College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Agra": {
        nearestMetro: "Delhi",
        metroDistance: 203,
        workProximityScore: 55,
        colleges: [
          { name: "Agra College", placement: 55, avgPackage: 3.8, type: "State University" },
          { name: "IIMT Agra", placement: 62, avgPackage: 4.5, type: "Private" },
          { name: "Other Agra College", placement: 48, avgPackage: 3.2, type: "Private" },
        ]
      },
      "Varanasi": {
        nearestMetro: "Lucknow",
        metroDistance: 286,
        workProximityScore: 52,
        colleges: [
          { name: "IIT BHU Varanasi", placement: 96, avgPackage: 20, type: "IIT" },
          { name: "Banaras Hindu University", placement: 72, avgPackage: 6, type: "Central University" },
          { name: "Other Varanasi College", placement: 50, avgPackage: 3.5, type: "Private" },
        ]
      },
      "Noida": {
        nearestMetro: "Delhi",
        metroDistance: 22,
        workProximityScore: 90,
        colleges: [
          { name: "Amity University Noida", placement: 82, avgPackage: 7.5, type: "Private University" },
          { name: "Jaypee Institute of Information Technology", placement: 85, avgPackage: 8.5, type: "Deemed University" },
          { name: "GL Bajaj Institute", placement: 76, avgPackage: 6, type: "Private Engineering" },
          { name: "Other Noida College", placement: 65, avgPackage: 5, type: "Private" },
        ]
      },
      "Ghaziabad": {
        nearestMetro: "Delhi",
        metroDistance: 32,
        workProximityScore: 85,
        colleges: [
          { name: "Galgotias University", placement: 78, avgPackage: 6, type: "Private University" },
          { name: "KIET Group of Institutions", placement: 80, avgPackage: 6.5, type: "Private Engineering" },
          { name: "Other Ghaziabad College", placement: 60, avgPackage: 4.5, type: "Private" },
        ]
      },
    }
  },

  // ── TELANGANA ─────────────────────────────────────────────────────────────
  Telangana: {
    districts: {
      "Hyderabad": {
        nearestMetro: "Hyderabad",
        metroDistance: 0,
        workProximityScore: 95,
        colleges: [
          { name: "IIT Hyderabad", placement: 97, avgPackage: 25, type: "IIT" },
          { name: "IIIT Hyderabad", placement: 96, avgPackage: 22, type: "Deemed University" },
          { name: "University of Hyderabad", placement: 75, avgPackage: 7, type: "Central University" },
          { name: "Osmania University", placement: 68, avgPackage: 5.5, type: "State University" },
          { name: "CBIT Hyderabad", placement: 85, avgPackage: 8, type: "Private Engineering" },
          { name: "VNR Vignana Jyothi", placement: 82, avgPackage: 7.5, type: "Private Engineering" },
          { name: "Chaitanya Bharathi Institute", placement: 80, avgPackage: 7, type: "Private Engineering" },
          { name: "Other Hyderabad College", placement: 65, avgPackage: 5, type: "Private" },
        ]
      },
      "Warangal": {
        nearestMetro: "Hyderabad",
        metroDistance: 148,
        workProximityScore: 65,
        colleges: [
          { name: "NIT Warangal", placement: 95, avgPackage: 15, type: "NIT" },
          { name: "Kakatiya University", placement: 62, avgPackage: 4.5, type: "State University" },
          { name: "Other Warangal College", placement: 52, avgPackage: 3.5, type: "Private" },
        ]
      },
      "Rangareddy": {
        nearestMetro: "Hyderabad",
        metroDistance: 30,
        workProximityScore: 88,
        colleges: [
          { name: "Mahindra University", placement: 88, avgPackage: 9, type: "Deemed University" },
          { name: "Sreenidhi Institute of Science", placement: 78, avgPackage: 6.5, type: "Private Engineering" },
          { name: "Other Rangareddy College", placement: 65, avgPackage: 5, type: "Private" },
        ]
      },
      "Nizamabad": {
        nearestMetro: "Hyderabad",
        metroDistance: 171,
        workProximityScore: 48,
        colleges: [
          { name: "Telangana University", placement: 55, avgPackage: 3.8, type: "State University" },
          { name: "Other Nizamabad College", placement: 45, avgPackage: 3, type: "Private" },
        ]
      },
    }
  },

  // ── WEST BENGAL ───────────────────────────────────────────────────────────
  "West Bengal": {
    districts: {
      "Kolkata": {
        nearestMetro: "Kolkata",
        metroDistance: 0,
        workProximityScore: 88,
        colleges: [
          { name: "IIT Kharagpur (nearby)", placement: 98, avgPackage: 28, type: "IIT" },
          { name: "Jadavpur University", placement: 90, avgPackage: 10, type: "State University" },
          { name: "Heritage Institute of Technology", placement: 82, avgPackage: 7.5, type: "Private Engineering" },
          { name: "Techno India University", placement: 74, avgPackage: 5.8, type: "Private University" },
          { name: "MAKAUT (WBUT) Colleges", placement: 65, avgPackage: 4.5, type: "State University" },
          { name: "Other Kolkata College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Kharagpur": {
        nearestMetro: "Kolkata",
        metroDistance: 120,
        workProximityScore: 72,
        colleges: [
          { name: "IIT Kharagpur", placement: 98, avgPackage: 28, type: "IIT" },
          { name: "Other Kharagpur College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Howrah": {
        nearestMetro: "Kolkata",
        metroDistance: 5,
        workProximityScore: 86,
        colleges: [
          { name: "IIEST Shibpur", placement: 86, avgPackage: 8, type: "Institute of National Importance" },
          { name: "Other Howrah College", placement: 60, avgPackage: 4.2, type: "Private" },
        ]
      },
    }
  },

  // ── GUJARAT ───────────────────────────────────────────────────────────────
  Gujarat: {
    districts: {
      "Ahmedabad": {
        nearestMetro: "Ahmedabad",
        metroDistance: 0,
        workProximityScore: 88,
        colleges: [
          { name: "IIT Gandhinagar", placement: 97, avgPackage: 24, type: "IIT" },
          { name: "DAIICT Gandhinagar", placement: 90, avgPackage: 12, type: "Deemed University" },
          { name: "LD College of Engineering", placement: 84, avgPackage: 8, type: "Govt Engineering" },
          { name: "Nirma University", placement: 86, avgPackage: 9, type: "Deemed University" },
          { name: "Ahmedabad University", placement: 82, avgPackage: 8, type: "Private University" },
          { name: "Other Ahmedabad College", placement: 65, avgPackage: 5, type: "Private" },
        ]
      },
      "Surat": {
        nearestMetro: "Surat",
        metroDistance: 0,
        workProximityScore: 78,
        colleges: [
          { name: "SVNIT Surat", placement: 88, avgPackage: 10, type: "NIT" },
          { name: "South Gujarat University", placement: 65, avgPackage: 4.8, type: "State University" },
          { name: "Other Surat College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Vadodara": {
        nearestMetro: "Ahmedabad",
        metroDistance: 110,
        workProximityScore: 74,
        colleges: [
          { name: "MSU Baroda (Faculty of Technology)", placement: 82, avgPackage: 7.5, type: "State University" },
          { name: "PDPU (Pandit Deendayal Energy)", placement: 88, avgPackage: 9, type: "State University" },
          { name: "Other Vadodara College", placement: 62, avgPackage: 4.5, type: "Private" },
        ]
      },
    }
  },

  // ── RAJASTHAN ─────────────────────────────────────────────────────────────
  Rajasthan: {
    districts: {
      "Jaipur": {
        nearestMetro: "Jaipur",
        metroDistance: 0,
        workProximityScore: 75,
        colleges: [
          { name: "IIT Jodhpur", placement: 94, avgPackage: 18, type: "IIT" },
          { name: "MNIT Jaipur", placement: 91, avgPackage: 12, type: "NIT" },
          { name: "Manipal University Jaipur", placement: 80, avgPackage: 7, type: "Private University" },
          { name: "LNM Institute of IT", placement: 85, avgPackage: 9, type: "Deemed University" },
          { name: "Rajasthan University", placement: 60, avgPackage: 4.2, type: "State University" },
          { name: "Other Jaipur College", placement: 56, avgPackage: 4, type: "Private" },
        ]
      },
      "Jodhpur": {
        nearestMetro: "Jaipur",
        metroDistance: 330,
        workProximityScore: 58,
        colleges: [
          { name: "IIT Jodhpur", placement: 94, avgPackage: 18, type: "IIT" },
          { name: "Jay Narain Vyas University", placement: 58, avgPackage: 4, type: "State University" },
          { name: "Other Jodhpur College", placement: 50, avgPackage: 3.5, type: "Private" },
        ]
      },
      "Udaipur": {
        nearestMetro: "Jaipur",
        metroDistance: 393,
        workProximityScore: 52,
        colleges: [
          { name: "Geetanjali College of Engineering", placement: 68, avgPackage: 5, type: "Private Engineering" },
          { name: "Mohanlal Sukhadia University", placement: 60, avgPackage: 4.2, type: "State University" },
          { name: "Other Udaipur College", placement: 50, avgPackage: 3.5, type: "Private" },
        ]
      },
    }
  },

  // ── ANDHRA PRADESH ────────────────────────────────────────────────────────
  "Andhra Pradesh": {
    districts: {
      "Visakhapatnam": {
        nearestMetro: "Hyderabad",
        metroDistance: 625,
        workProximityScore: 65,
        colleges: [
          { name: "GITAM University", placement: 82, avgPackage: 7, type: "Deemed University" },
          { name: "Andhra University", placement: 68, avgPackage: 5, type: "State University" },
          { name: "MVGR College of Engineering", placement: 74, avgPackage: 5.8, type: "Private Engineering" },
          { name: "Other Vizag College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Vijayawada": {
        nearestMetro: "Hyderabad",
        metroDistance: 270,
        workProximityScore: 62,
        colleges: [
          { name: "VIT Amaravati", placement: 78, avgPackage: 6.5, type: "Deemed University" },
          { name: "RVR & JC College of Engineering", placement: 74, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Vijayawada College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Tirupati": {
        nearestMetro: "Chennai",
        metroDistance: 135,
        workProximityScore: 70,
        colleges: [
          { name: "SV University", placement: 65, avgPackage: 4.8, type: "State University" },
          { name: "SVCE Tirupati", placement: 72, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Tirupati College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Guntur": {
        nearestMetro: "Hyderabad",
        metroDistance: 280,
        workProximityScore: 56,
        colleges: [
          { name: "Acharya Nagarjuna University", placement: 60, avgPackage: 4.2, type: "State University" },
          { name: "Bapatla Engineering College", placement: 68, avgPackage: 5, type: "Private Engineering" },
          { name: "Other Guntur College", placement: 50, avgPackage: 3.4, type: "Private" },
        ]
      },
    }
  },

  // ── MADHYA PRADESH ────────────────────────────────────────────────────────
  "Madhya Pradesh": {
    districts: {
      "Indore": {
        nearestMetro: "Indore",
        metroDistance: 0,
        workProximityScore: 76,
        colleges: [
          { name: "IIT Indore", placement: 96, avgPackage: 20, type: "IIT" },
          { name: "IIM Indore", placement: 100, avgPackage: 28, type: "IIM" },
          { name: "SGSITS Indore", placement: 78, avgPackage: 6.5, type: "Govt Engineering" },
          { name: "Acropolis Institute", placement: 72, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Indore College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Bhopal": {
        nearestMetro: "Indore",
        metroDistance: 189,
        workProximityScore: 68,
        colleges: [
          { name: "MANIT Bhopal", placement: 88, avgPackage: 10, type: "NIT" },
          { name: "RKDF University", placement: 70, avgPackage: 5.2, type: "Private University" },
          { name: "Bhopal School of Social Sciences", placement: 65, avgPackage: 4.8, type: "Private" },
          { name: "Other Bhopal College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Gwalior": {
        nearestMetro: "Delhi",
        metroDistance: 321,
        workProximityScore: 55,
        colleges: [
          { name: "IIITM Gwalior", placement: 86, avgPackage: 9, type: "Institute of National Importance" },
          { name: "ITM University Gwalior", placement: 68, avgPackage: 5, type: "Private University" },
          { name: "Other Gwalior College", placement: 52, avgPackage: 3.6, type: "Private" },
        ]
      },
    }
  },

  // ── PUNJAB ────────────────────────────────────────────────────────────────
  Punjab: {
    districts: {
      "Chandigarh (UT)": {
        nearestMetro: "Chandigarh",
        metroDistance: 0,
        workProximityScore: 80,
        colleges: [
          { name: "PEC Chandigarh", placement: 88, avgPackage: 9.5, type: "Govt Engineering" },
          { name: "Panjab University", placement: 72, avgPackage: 6, type: "Central University" },
          { name: "Chitkara University", placement: 80, avgPackage: 7, type: "Private University" },
          { name: "Other Chandigarh College", placement: 62, avgPackage: 4.8, type: "Private" },
        ]
      },
      "Ludhiana": {
        nearestMetro: "Chandigarh",
        metroDistance: 100,
        workProximityScore: 70,
        colleges: [
          { name: "PTU (IK Gujral Punjab Technical Univ)", placement: 70, avgPackage: 5.5, type: "State University" },
          { name: "Guru Nanak Dev Engineering College", placement: 75, avgPackage: 6, type: "Govt Engineering" },
          { name: "Other Ludhiana College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Amritsar": {
        nearestMetro: "Chandigarh",
        metroDistance: 228,
        workProximityScore: 58,
        colleges: [
          { name: "GNDU Amritsar", placement: 65, avgPackage: 4.8, type: "State University" },
          { name: "Other Amritsar College", placement: 52, avgPackage: 3.5, type: "Private" },
        ]
      },
    }
  },

  // ── KERALA ────────────────────────────────────────────────────────────────
  Kerala: {
    districts: {
      "Thiruvananthapuram": {
        nearestMetro: "Kochi",
        metroDistance: 220,
        workProximityScore: 68,
        colleges: [
          { name: "Kerala University", placement: 70, avgPackage: 5.5, type: "State University" },
          { name: "College of Engineering Trivandrum", placement: 82, avgPackage: 7.5, type: "Govt Engineering" },
          { name: "TKM College of Engineering", placement: 78, avgPackage: 6.5, type: "Govt Engineering" },
          { name: "Other Trivandrum College", placement: 60, avgPackage: 4.2, type: "Private" },
        ]
      },
      "Ernakulam / Kochi": {
        nearestMetro: "Kochi",
        metroDistance: 0,
        workProximityScore: 80,
        colleges: [
          { name: "CUSAT Cochin", placement: 85, avgPackage: 8, type: "Central University" },
          { name: "NIT Calicut (nearby)", placement: 92, avgPackage: 13, type: "NIT" },
          { name: "Rajagiri College of Engineering", placement: 80, avgPackage: 7, type: "Private Engineering" },
          { name: "Other Kochi College", placement: 65, avgPackage: 4.8, type: "Private" },
        ]
      },
      "Kozhikode": {
        nearestMetro: "Kochi",
        metroDistance: 118,
        workProximityScore: 65,
        colleges: [
          { name: "NIT Calicut", placement: 92, avgPackage: 13, type: "NIT" },
          { name: "University of Calicut", placement: 65, avgPackage: 4.8, type: "State University" },
          { name: "Other Kozhikode College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Thrissur": {
        nearestMetro: "Kochi",
        metroDistance: 80,
        workProximityScore: 72,
        colleges: [
          { name: "Government Engineering College Thrissur", placement: 78, avgPackage: 6.5, type: "Govt Engineering" },
          { name: "TOCH Institute of Science", placement: 72, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other Thrissur College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
    }
  },

  // ── HARYANA ───────────────────────────────────────────────────────────────
  Haryana: {
    districts: {
      "Gurugram": {
        nearestMetro: "Delhi",
        metroDistance: 30,
        workProximityScore: 92,
        colleges: [
          { name: "Amity University Gurugram", placement: 80, avgPackage: 7.5, type: "Private University" },
          { name: "IILM University", placement: 75, avgPackage: 6.5, type: "Private University" },
          { name: "Other Gurugram College", placement: 65, avgPackage: 5.5, type: "Private" },
        ]
      },
      "Faridabad": {
        nearestMetro: "Delhi",
        metroDistance: 30,
        workProximityScore: 86,
        colleges: [
          { name: "J.C. Bose University of Science", placement: 78, avgPackage: 6.5, type: "State University" },
          { name: "Manav Rachna University", placement: 74, avgPackage: 6, type: "Deemed University" },
          { name: "Other Faridabad College", placement: 60, avgPackage: 4.5, type: "Private" },
        ]
      },
      "Rohtak": {
        nearestMetro: "Delhi",
        metroDistance: 72,
        workProximityScore: 72,
        colleges: [
          { name: "MDU Rohtak", placement: 65, avgPackage: 4.8, type: "State University" },
          { name: "DCRUST Murthal", placement: 74, avgPackage: 6, type: "State University" },
          { name: "Other Rohtak College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Sonipat": {
        nearestMetro: "Delhi",
        metroDistance: 45,
        workProximityScore: 80,
        colleges: [
          { name: "DCRUST Murthal", placement: 74, avgPackage: 6, type: "State University" },
          { name: "Shree Ram College", placement: 68, avgPackage: 5.2, type: "Private" },
          { name: "Other Sonipat College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
    }
  },

  // ── BIHAR ────────────────────────────────────────────────────────────────
  Bihar: {
    districts: {
      "Patna": {
        nearestMetro: "Lucknow",
        metroDistance: 280,
        workProximityScore: 50,
        colleges: [
          { name: "IIT Patna", placement: 92, avgPackage: 16, type: "IIT" },
          { name: "NIT Patna", placement: 82, avgPackage: 9, type: "NIT" },
          { name: "Patna University", placement: 55, avgPackage: 4, type: "State University" },
          { name: "Other Patna College", placement: 45, avgPackage: 3.2, type: "Private" },
        ]
      },
      "Gaya": {
        nearestMetro: "Lucknow",
        metroDistance: 380,
        workProximityScore: 38,
        colleges: [
          { name: "Magadh University", placement: 48, avgPackage: 3.2, type: "State University" },
          { name: "Other Gaya College", placement: 40, avgPackage: 2.8, type: "Private" },
        ]
      },
      "Muzaffarpur": {
        nearestMetro: "Lucknow",
        metroDistance: 390,
        workProximityScore: 36,
        colleges: [
          { name: "BRA Bihar University", placement: 48, avgPackage: 3, type: "State University" },
          { name: "Other Muzaffarpur College", placement: 40, avgPackage: 2.8, type: "Private" },
        ]
      },
    }
  },

  // ── ODISHA ────────────────────────────────────────────────────────────────
  Odisha: {
    districts: {
      "Bhubaneswar": {
        nearestMetro: "Kolkata",
        metroDistance: 445,
        workProximityScore: 60,
        colleges: [
          { name: "IIT Bhubaneswar", placement: 92, avgPackage: 16, type: "IIT" },
          { name: "NIT Rourkela", placement: 88, avgPackage: 11, type: "NIT" },
          { name: "KIIT University", placement: 84, avgPackage: 8.5, type: "Deemed University" },
          { name: "SOA University", placement: 78, avgPackage: 7, type: "Deemed University" },
          { name: "Other Bhubaneswar College", placement: 60, avgPackage: 4.2, type: "Private" },
        ]
      },
      "Rourkela": {
        nearestMetro: "Kolkata",
        metroDistance: 400,
        workProximityScore: 55,
        colleges: [
          { name: "NIT Rourkela", placement: 88, avgPackage: 11, type: "NIT" },
          { name: "Other Rourkela College", placement: 52, avgPackage: 3.8, type: "Private" },
        ]
      },
    }
  },

  // ── JHARKHAND ────────────────────────────────────────────────────────────
  Jharkhand: {
    districts: {
      "Ranchi": {
        nearestMetro: "Kolkata",
        metroDistance: 380,
        workProximityScore: 48,
        colleges: [
          { name: "IIT ISM Dhanbad", placement: 90, avgPackage: 13, type: "IIT" },
          { name: "BIT Mesra", placement: 82, avgPackage: 8, type: "Deemed University" },
          { name: "Ranchi University", placement: 52, avgPackage: 3.5, type: "State University" },
          { name: "Other Ranchi College", placement: 45, avgPackage: 3, type: "Private" },
        ]
      },
      "Dhanbad": {
        nearestMetro: "Kolkata",
        metroDistance: 265,
        workProximityScore: 55,
        colleges: [
          { name: "IIT (ISM) Dhanbad", placement: 90, avgPackage: 13, type: "IIT" },
          { name: "Other Dhanbad College", placement: 50, avgPackage: 3.5, type: "Private" },
        ]
      },
    }
  },

  // ── ASSAM ─────────────────────────────────────────────────────────────────
  Assam: {
    districts: {
      "Guwahati": {
        nearestMetro: "Kolkata",
        metroDistance: 1000,
        workProximityScore: 55,
        colleges: [
          { name: "IIT Guwahati", placement: 94, avgPackage: 18, type: "IIT" },
          { name: "NIT Silchar", placement: 82, avgPackage: 8, type: "NIT" },
          { name: "Gauhati University", placement: 62, avgPackage: 4.5, type: "State University" },
          { name: "Assam Engineering College", placement: 72, avgPackage: 5.5, type: "Govt Engineering" },
          { name: "Other Guwahati College", placement: 55, avgPackage: 3.8, type: "Private" },
        ]
      },
      "Dibrugarh": {
        nearestMetro: "Guwahati",
        metroDistance: 450,
        workProximityScore: 38,
        colleges: [
          { name: "Dibrugarh University", placement: 55, avgPackage: 3.8, type: "State University" },
          { name: "Other Dibrugarh College", placement: 45, avgPackage: 3, type: "Private" },
        ]
      },
    }
  },

  // ── HIMACHAL PRADESH ─────────────────────────────────────────────────────
  "Himachal Pradesh": {
    districts: {
      "Shimla": {
        nearestMetro: "Chandigarh",
        metroDistance: 118,
        workProximityScore: 55,
        colleges: [
          { name: "Himachal Pradesh University", placement: 58, avgPackage: 4, type: "State University" },
          { name: "NIT Hamirpur", placement: 84, avgPackage: 8.5, type: "NIT" },
          { name: "Other Shimla College", placement: 50, avgPackage: 3.5, type: "Private" },
        ]
      },
      "Hamirpur": {
        nearestMetro: "Chandigarh",
        metroDistance: 190,
        workProximityScore: 52,
        colleges: [
          { name: "NIT Hamirpur", placement: 84, avgPackage: 8.5, type: "NIT" },
          { name: "Other Hamirpur College", placement: 50, avgPackage: 3.5, type: "Private" },
        ]
      },
    }
  },

  // ── UTTARAKHAND ──────────────────────────────────────────────────────────
  Uttarakhand: {
    districts: {
      "Dehradun": {
        nearestMetro: "Delhi",
        metroDistance: 300,
        workProximityScore: 60,
        colleges: [
          { name: "IIT Roorkee", placement: 97, avgPackage: 22, type: "IIT" },
          { name: "Graphic Era University", placement: 78, avgPackage: 6.5, type: "Deemed University" },
          { name: "DIT University", placement: 72, avgPackage: 5.8, type: "Private University" },
          { name: "Other Dehradun College", placement: 58, avgPackage: 4, type: "Private" },
        ]
      },
      "Roorkee": {
        nearestMetro: "Delhi",
        metroDistance: 184,
        workProximityScore: 65,
        colleges: [
          { name: "IIT Roorkee", placement: 97, avgPackage: 22, type: "IIT" },
          { name: "Other Roorkee College", placement: 55, avgPackage: 4, type: "Private" },
        ]
      },
    }
  },

  // ── GOA ──────────────────────────────────────────────────────────────────
  Goa: {
    districts: {
      "North Goa": {
        nearestMetro: "Mumbai",
        metroDistance: 585,
        workProximityScore: 65,
        colleges: [
          { name: "IIT Goa", placement: 90, avgPackage: 15, type: "IIT" },
          { name: "NIT Goa", placement: 82, avgPackage: 9, type: "NIT" },
          { name: "Goa University", placement: 68, avgPackage: 5.5, type: "State University" },
          { name: "Other Goa College", placement: 58, avgPackage: 4.2, type: "Private" },
        ]
      },
      "South Goa": {
        nearestMetro: "Mumbai",
        metroDistance: 600,
        workProximityScore: 58,
        colleges: [
          { name: "Padre Conceicao College of Engineering", placement: 70, avgPackage: 5.5, type: "Private Engineering" },
          { name: "Other South Goa College", placement: 55, avgPackage: 4, type: "Private" },
        ]
      },
    }
  },

  // ── CHHATTISGARH ─────────────────────────────────────────────────────────
  Chhattisgarh: {
    districts: {
      "Raipur": {
        nearestMetro: "Nagpur",
        metroDistance: 295,
        workProximityScore: 48,
        colleges: [
          { name: "NIT Raipur", placement: 80, avgPackage: 7.5, type: "NIT" },
          { name: "Chhattisgarh Swami Vivekanand Technical University", placement: 60, avgPackage: 4, type: "State University" },
          { name: "Other Raipur College", placement: 48, avgPackage: 3.2, type: "Private" },
        ]
      },
      "Bhilai": {
        nearestMetro: "Nagpur",
        metroDistance: 285,
        workProximityScore: 50,
        colleges: [
          { name: "CSVTU Bhilai", placement: 62, avgPackage: 4.2, type: "State University" },
          { name: "Other Bhilai College", placement: 50, avgPackage: 3.5, type: "Private" },
        ]
      },
    }
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// HELPER FUNCTIONS
// ─────────────────────────────────────────────────────────────────────────────

export const getStates = () => Object.keys(INDIA_DATA).sort();

export const getDistricts = (state) => {
  if (!state || !INDIA_DATA[state]) return [];
  return Object.keys(INDIA_DATA[state].districts).sort();
};

export const getColleges = (state, district) => {
  if (!state || !district) return [];
  return INDIA_DATA[state]?.districts[district]?.colleges || [];
};

export const getDistrictInfo = (state, district) => {
  if (!state || !district) return null;
  return INDIA_DATA[state]?.districts[district] || null;
};

// Calculate work probability score (0-100)
export const calcWorkProbability = (state, district, collegeName) => {
  const distInfo = getDistrictInfo(state, district);
  if (!distInfo) return 50;

  const college = distInfo.colleges.find(c => c.name === collegeName);
  const placementScore = college ? college.placement : 55;
  const metroScore = distInfo.workProximityScore;

  // Weighted formula
  const workProb = Math.round(placementScore * 0.55 + metroScore * 0.45);
  return Math.min(99, Math.max(20, workProb));
};

// Metro proximity label
export const getProximityLabel = (state, district) => {
  const info = getDistrictInfo(state, district);
  if (!info) return "Unknown";
  const { metroDistance, nearestMetro } = info;
  if (metroDistance === 0) return `📍 ${nearestMetro} Metro City`;
  if (metroDistance <= 50) return `🔵 ${metroDistance}km from ${nearestMetro}`;
  if (metroDistance <= 150) return `🟡 ${metroDistance}km from ${nearestMetro}`;
  if (metroDistance <= 300) return `🟠 ${metroDistance}km from ${nearestMetro}`;
  return `🔴 ${metroDistance}km from ${nearestMetro}`;
};